import { endpoints } from '../endpoints'
import { http } from '../http'
import { VeteranContactFormValues, VeteranContactResponse } from '../../types'

interface VeteranContactAPI {
  submit: (params: VeteranContactFormValues) => Promise<VeteranContactResponse>
}

const toSnakeCasePayload = (params: VeteranContactFormValues): Record<string, string> => ({
  name: params.name,
  phone: params.phone,
  email: params.email,
  how_can_we_help: params.howCanWeHelp,
  when_assistance: params.whenAssistance,
  additional_notes: params.additionalNotes,
  preferred_contact_method: params.preferredContactMethod,
})

export const veteranContact: VeteranContactAPI = {
  submit: (params) => {
    return http.post(endpoints.veteranContact, {
      veteran_contact: toSnakeCasePayload(params),
    })
  },
}
